<template lang="pug">
  v-popover(
    :placement='actionsPlacement'
    :delay='{show: 100, hide: 600}'
    trigger='hover click'
    popoverClass='krea-actions-popover'
    :container='false'
  )
    .column.m-bottom-2
      .row.middle.m-bottom-05
        simple-svg.dark-gray-icon.m-right-1(:filepath='udlIcon' width='18px' height='18px')
        label.text-small.dark-gray {{ $t("krea.educationalContent.udlLabel") }}
      .labels.row.middle.m-left-3(v-if='edition || !content.udLs.length')
        label.select.text-small.dark-gray.m-bottom-05 {{ $t("udls.type.engagement") }}
        label.select.text-small.dark-gray.m-bottom-05 {{ $t("udls.type.representation") }}
        label.select.text-small.dark-gray.m-bottom-05 {{ $t("udls.type.actionAndExpression") }}
      .udls.row.middle.m-left-3(v-if='edition || !content.udLs.length')
        krea-k-select.select(
          v-if='edition'
          name='engagement' noActions small
          :placeholder='$t("krea.educationalContent.udlPlaceholder")'
          :emptyOption='$t("krea.educationalContent.udlEmptyOption")'
          @selectOption='updateUdl'
          :value='getSelectedUdl(udlTypes.engagement)'
          :options='getUdlOptions(udlTypes.engagement)'
        )
        krea-k-select.select(
          v-if='edition'
          name='representation' noActions small
          :placeholder='$t("krea.educationalContent.udlPlaceholder")'
          :emptyOption='$t("krea.educationalContent.udlEmptyOption")'
          @selectOption='updateUdl'
          :value='getSelectedUdl(udlTypes.representation)'
          :options='getUdlOptions(udlTypes.representation)'
        )
        krea-k-select.select(
          v-if='edition'
          name='actionAndExpression' noActions small
          :placeholder='$t("krea.educationalContent.udlPlaceholder")'
          :emptyOption='$t("krea.educationalContent.udlEmptyOption")'
          @selectOption='updateUdl'
          :value='getSelectedUdl(udlTypes.actionAndExpression)'
          :options='getUdlOptions(udlTypes.actionAndExpression)'
        )
      p.text-normal.m-left-3(v-else) {{ udls }}
    template(slot="popover")
      actions(
        @edit='toggleEdition'
        :edit='edit'
        :comments='comments'
        :pdf='pdf'
        :link='link'
        :info='info'
        :placement='actionsPlacement.split("-")[1]'
      )
</template>

<script>
import KreaKSelect from '../Inputs/KreaKSelect'
import { udlTypes } from '@/constants/udls'
import { mapActions, mapState } from 'vuex'
import kreaActions from '@/mixins/kreaActions'
import Actions from '../Inputs/Actions/Actions'
import udlIcon from '@/assets/ic_udl.svg'

export default {
  mixins: [ kreaActions ],
  components: { KreaKSelect, Actions },
  data() {
    return {
      udlTypes,
      udlIcon,
      edition: true
    }
  },
  computed: {
    ...mapState({
      udlOptions: state => state.dashboard.udls,
      content: state => state.kreaEducationalContent.content
    }),
    udls() {
      return this.content.udLs
        .map(udl => udl.name)
        .join(', ')
    }
  },
  methods: {
    ...mapActions([
      'editKreaContentField'
    ]),
    toggleEdition() {
      if (!this.content.udLs.length) return
      this.edition = !this.edition
    },
    getUdlOptions(type) {
      return this.udlOptions
        .filter(udl => udl.type === type)
        .map(udl => ({ ...udl, label: udl.name, value: udl.id }))
    },
    getSelectedUdl(type) {
      if (!this.content.udLs) return
      const udl = this.content.udLs.find(udl => udl.type === type)
      return udl ? udl.id : null
    },
    updateUdl(field, val, option) {
      let value
      if (val) {
        value = [...this.content.udLs.filter(udl => udl.type !== option.type), option]
      } else {
        value = this.content.udLs
          .filter(udl => {
            const udlType = Object.values(udlTypes).find(value => udlTypes[field] === value)
            return udl.type !== udlType
          })
      }
      this.editKreaContentField({ field: 'udLs', value })
    }
  }
}
</script>

<style lang="scss" scoped>

.udls, .labels{
  gap: 10px;
  .udls-label{
    display: block;
  }
}
.select{
  width: 180px;
}
</style>
